<template>
  <div style="padding: 20px; background: rgb(221, 225, 230); border: 1px solid rgb(204, 204, 204)">
    <v-card class="mb-4" v-if="list_access">
      <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
        <div class="col-md-12">
          <div class="col-md-12" style="background: white">
            <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
            <v-divider class="mt-0"></v-divider>

            <div class="row pt-2">
              <div class="col-md-3">
                <v-text-field v-model="filters.date_from" density="comfortable" type="date" name="date_from" label="Desde" :disabled="disabled"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="filters.date_to" density="comfortable" type="date" name="date_to" label="hasta" :disabled="disabled"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-combobox v-model="filters.almacen" density="comfortable" item-title="name" item-value="id" :items="almacenes" label="Almacen" autocomplete="off" clearable></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox v-if="!isClient()" v-model="filters.client" density="comfortable" item-title="name" item-value="id" :items="clients" label="Cliente" autocomplete="off" clearable></v-combobox>
              </div>

              <div class="col-md-12 pt-2 pb-2" style="display: flex; justify-content: end">
                <v-btn color="blue-grey" class="mr-3" small dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
                <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <v-card v-if="list_access">
      <v-card-title>
        <v-row align="center" class="mt-1">
          <v-col>
            <span>{{ page_title }}</span>
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" variant="text" size="small" icon class="ml-2" aria-label="Cómo leer este reporte" @click="dialog_info = true">
                  <v-icon color="grey">mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>Cómo leer este reporte</span>
            </v-tooltip>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table :headers="headers" :items="list" :search="search" :custom-filter="searchFilter" :loading="loading" loading-text="Cargando...">
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.fecha }}</td>
            <td>
              <div>{{ item.orden_envio }}</div>
              <span class="text-caption text-grey-600 d-block">{{ item.canal_venta || "-" }}</span>
            </td>
            <td v-if="!isClient()">{{ item.cliente }}</td>
            <td class="text-center">
              <div>{{ item.cantidad_sku }} SKU</div>
              <span class="text-caption text-grey-600 d-block">{{ item.cantidad_unidades }} u.</span>
            </td>
            <td class="text-center">
              <div>{{ item.cantidad_tareas_picking }}</div>
              <v-tooltip location="top" v-if="Number(item.tareas_sin_realizar) > 0">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" size="x-small" variant="tonal" color="orange" class="mt-1">{{ item.tareas_sin_realizar }} sin hacer</v-chip>
                </template>
                <span>{{ item.tareas_sin_realizar }} tareas de picking no se ejecutaron (canceladas o sin completar). Los tiempos de esta fila pueden no ser comparables con el resto.</span>
              </v-tooltip>
            </td>
            <td>
              <div class="nowrap">
                {{ rangoPreparacion(item) }}
                <v-chip v-if="hasDuracion(item.segundos_preparacion)" size="x-small" variant="tonal" color="blue-grey" class="ml-1">{{ formatUtils.formatSeconds(item.segundos_preparacion) }}</v-chip>
              </div>
              <span class="text-caption text-grey-600 d-block">{{ empleadoPreparacion(item) }}</span>
            </td>
            <td>
              <div class="nowrap">
                {{ formatUtils.formatHora(item.hora_empaquetado, item.fecha) }}
                <v-chip v-if="hasDuracion(item.segundos_empaquetado)" size="x-small" variant="tonal" color="blue-grey" class="ml-1">{{ formatUtils.formatSeconds(item.segundos_empaquetado) }}</v-chip>
              </div>
              <span class="text-caption text-grey-600 d-block">{{ item.empleado_empaquetado || "-" }}</span>
            </td>
            <td>
              <div class="nowrap">
                {{ formatUtils.formatHora(item.hora_expedicion, item.fecha) }}
                <v-chip v-if="hasDuracion(item.segundos_expedicion)" size="x-small" variant="tonal" color="blue-grey" class="ml-1">{{ formatUtils.formatSeconds(item.segundos_expedicion) }}</v-chip>
              </div>
              <span class="text-caption text-grey-600 d-block">{{ item.empleado_expedicion || "-" }}</span>
            </td>
            <td class="text-center">
              <v-chip v-if="hasDuracion(item.segundos_total)" size="x-small" variant="tonal" color="blue-grey">{{ formatUtils.formatSeconds(item.segundos_total) }}</v-chip>
              <span v-else>-</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <DialogInfo :dialog="dialog_info" title="Cómo leer este reporte" @updateDialog="dialog_info = $event">
      <div class="pt-4">
        <p class="text-h6 mb-1">¿Qué muestra?</p>
        <v-divider class="mb-3"></v-divider>
        <p class="text-body-2 mb-2">Una fila por pedido expedido, con el recorrido completo: cuándo se preparó, se empaquetó y se expidió, quién hizo cada paso y cuánto pasó entre una etapa y la siguiente.</p>
        <p class="text-body-2 mb-4">Si una hora cae en otro día, se marca al lado con -1d o +1d.</p>

        <p class="text-h6 mb-1">Pedidos de una sola tarea</p>
        <v-divider class="mb-3"></v-divider>
        <v-alert type="info" variant="tonal" density="compact" class="text-body-2 mb-4">
          Cuando un pedido se junta en una sola tarea de picking, pasa directo a Preparado sin pasar por En preparación. En esos casos la columna Preparación muestra solo la hora en que quedó listo, sin duración: no hubo un intervalo que medir. El Total de esos pedidos se cuenta desde que quedaron preparados.
        </v-alert>

        <p class="text-h6 mb-1">Las columnas</p>
        <v-divider class="mb-3"></v-divider>
        <div class="text-body-2">
          <div class="mb-3">
            <span class="font-weight-bold">Orden de Envío</span> —
            <span class="text-grey-600">El código del pedido y, abajo, el canal de venta.</span>
          </div>
          <div class="mb-3">
            <span class="font-weight-bold">Contenido</span> —
            <span class="text-grey-600">Cuántos productos distintos lleva el pedido y, abajo, el total de unidades despachadas.</span>
          </div>
          <div class="mb-3">
            <span class="font-weight-bold">Tareas de Picking</span> —
            <span class="text-grey-600">Cuántas tareas de picking se ejecutaron para juntar el pedido. Si quedaron tareas sin ejecutar, aparece debajo en naranja cuántas fueron. Puede ser porque el pedido se cerró antes de terminarlas, o porque el sistema las canceló al cubrirse la cantidad con otra tarea. En esos casos conviene mirar los tiempos de la fila con cuidado: pueden no reflejar el trabajo real.</span>
          </div>
          <div class="mb-3">
            <span class="font-weight-bold">Preparación</span> —
            <span class="text-grey-600">De cuándo se empezó a preparar a cuándo quedó listo, con el tiempo que llevó. Abajo, el operario; si lo empezó uno y lo terminó otro, aparecen los dos.</span>
          </div>
          <div class="mb-3">
            <span class="font-weight-bold">Empaquetado</span> —
            <span class="text-grey-600">La hora y el tiempo que pasó desde que el pedido quedó preparado. Abajo, quién lo empaquetó.</span>
          </div>
          <div class="mb-3">
            <span class="font-weight-bold">Expedición</span> —
            <span class="text-grey-600">La hora de salida y el tiempo desde que se empaquetó. Abajo, quién la hizo.</span>
          </div>
          <div class="mb-3">
            <span class="font-weight-bold">Total</span> —
            <span class="text-grey-600">Cuánto tardó el pedido en total, desde que se empezó a preparar hasta que salió.</span>
          </div>
        </div>
      </div>
    </DialogInfo>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { reportsService } from "@/libs/ws/reportsService";
import { almacenService } from "@/libs/ws/almacenService";
import { clientService } from "@/libs/ws/clientService";
import UserTypeConstant from "@/constants/user_type";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import { formatUtils } from "@/libs/utils/formatUtils";
export default {
  components: {},
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      service: reportsService,
      page_title: "Productividad por Envío",
      userTypeConstant: UserTypeConstant,
      user_type: null,
      dialog_info: false,
      formatUtils: formatUtils,
      headers: [
        {
          title: "Fecha",
          align: "left",
          sortable: true,
          value: "fecha",
          width: "100px",
          visible: true,
        },
        {
          title: "Orden de Envío",
          align: "left",
          sortable: true,
          value: "orden_envio",
          width: "150px",
          visible: true,
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          value: "cliente",
          width: "150px",
          visible: true,
          visible_for_client: false,
        },
        {
          title: "Contenido",
          align: "center",
          sortable: true,
          value: "cantidad_sku",
          width: "110px",
          visible: true,
        },
        {
          title: "Tareas de Picking",
          align: "center",
          sortable: true,
          value: "cantidad_tareas_picking",
          width: "130px",
          visible: true,
        },
        {
          title: "Preparación",
          align: "left",
          sortable: true,
          value: "hora_fin_preparacion",
          width: "230px",
          visible: true,
        },
        {
          title: "Empaquetado",
          align: "left",
          sortable: true,
          value: "hora_empaquetado",
          width: "190px",
          visible: true,
        },
        {
          title: "Expedición",
          align: "left",
          sortable: true,
          value: "hora_expedicion",
          width: "190px",
          visible: true,
        },
        {
          title: "Total",
          align: "center",
          sortable: true,
          value: "segundos_total",
          width: "90px",
          visible: true,
        },
      ],
      filters: {
        date_from: new Date(
          new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        almacen: null,
        client: null,
      },

      almacenes: [],
      clients: [],
    };
  },
  mounted() {
    this.user_type = localStorage.getItem("user_type");
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));

    //recorro los headers y saco el cliente si el usuario es el cliente
    this.headers = this.headers.filter((header) => {
      if (header.visible_for_client || header.visible_for_client == undefined) {
        return true;
      }
      return !this.isClient();
    });

    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
    this.loadAlmacenes();
    this.loadClientes();
  },
  methods: {
    hasDuracion(seg) {
      return seg !== null && seg !== undefined && seg !== "" && Number(seg) >= 0;
    },
    rangoPreparacion(item) {
      const fin = formatUtils.formatHora(item.hora_fin_preparacion, item.fecha);
      if (!item.hora_inicio_preparacion) return fin;
      return formatUtils.formatHora(item.hora_inicio_preparacion, item.fecha) + " → " + fin;
    },
    empleadoPreparacion(item) {
      const a = item.empleado_inicio_preparacion;
      const b = item.empleado_fin_preparacion;
      if (!a && !b) return "-";
      if (!a || !b || a === b) return a || b;
      return a + " → " + b;
    },
    searchFilter(value, query, item) {
      const q = (query || "").toString().toLowerCase();
      if (!q) return true;
      const fields = ["fecha", "orden_envio", "cliente", "canal_venta", "empleado_inicio_preparacion", "empleado_fin_preparacion", "empleado_empaquetado", "empleado_expedicion"];
      return fields.some((f) => (item.raw[f] || "").toString().toLowerCase().includes(q)) ? true : -1;
    },
    loadClientes() {
      if(this.isClient()){
        return;
      }

      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.loadClientes error");
          console.log(e);
        });
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.loadAlmacenes error");
          console.log(e);
        });
    },
    getFilterParams() {
      return this.filters;
    },
    loadList(service, param = null) {
      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      reportsService
        .productividad(param)
        .then((response) => {
          this.list = response.result;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.productividad error");
          console.log(e);
          this.loading = false;
        });
    },
    filter() {
      this.loadList(this.service, this.filters);
    },
    exportFile() {
      var param = { ...this.getFilterParams() }; // Copia de this.filters
      param["export"] = true;
      this.exportExcel(Constant.SECTION_REPORTS + "/productividad", param, "Productividad.xlsx");
    },
  },
};
</script>
